import Datetime from 'utils/datetime/datetime'

export function getBidTimestamp(baseStartTime: Date, hourIndex: number): ISODateTime {
  return Datetime.addHours(Datetime.toISOString(baseStartTime), hourIndex)
}

export function getBidHourRangeLabel(baseStartTime: Date, hourIndex: number): string {
  const start = new Date(baseStartTime)
  start.setHours(baseStartTime.getHours() + hourIndex)

  const end = new Date(start)
  end.setHours(start.getHours() + 1)

  const formatTime = (date: Date) =>
    `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`

  return `${formatTime(start)} - ${formatTime(end)}`
}

export function getBidRowDateLabel(baseStartTime: Date, hourIndex: number): string {
  const start = new Date(baseStartTime)
  start.setHours(baseStartTime.getHours() + hourIndex)
  return Datetime.toLocalTime(Datetime.toISOString(start), 'onlyDate')
}
